import { Link } from 'react-router-dom';

const AllServicesGrid = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado de pisos y casas',
      description: 'Servicio completo de vaciado de viviendas en Castelldefels y comarca. Retiramos muebles, enseres, electrodomésticos y todo tipo de objetos. Incluye limpieza final y gestión de residuos. Ideal para herencias, mudanzas, desahucios o preparación de inmuebles para venta o alquiler.',
      features: [
        'Retirada completa de muebles y enseres',
        'Limpieza profunda post-vaciado',
        'Gestión legal de residuos',
        'Servicio urgente disponible 24/7',
        'Presupuesto sin compromiso'
      ],
      image: 'https://public.readdy.ai/ai/img_res/215149b52b99563695c5ce68b291b4bf.jpg',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vaciado de locales comerciales',
      description: 'Vaciado profesional de oficinas, tiendas, almacenes y espacios comerciales de cualquier tamaño en Castelldefels, Gavà y Viladecans. Retiramos mobiliario de oficina, estanterías, maquinaria, stock y todo tipo de equipamiento comercial. Servicio rápido y eficiente.',
      features: [
        'Vaciado de oficinas y tiendas',
        'Retirada de mobiliario comercial',
        'Gestión de equipamiento y maquinaria',
        'Horarios flexibles fuera de horario comercial',
        'Certificado de gestión de residuos'
      ],
      image: 'https://readdy.ai/api/search-image?query=Empty%20commercial%20office%20space%20bright%20modern%20interior%20large%20windows%20clean%20environment&width=800&height=600&seq=service-2&orientation=landscape',
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Retirada de muebles y electrodomésticos',
      description: 'Servicio especializado en recogida y retirada de muebles voluminosos, electrodomésticos, colchones y enseres en Castelldefels y alrededores. Nos encargamos del transporte y gestión responsable de residuos, incluyendo reciclaje y donación de objetos en buen estado.',
      features: [
        'Recogida de muebles voluminosos',
        'Retirada de electrodomésticos',
        'Transporte y carga incluidos',
        'Reciclaje y donación responsable',
        'Servicio el mismo día disponible'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carrying%20furniture%20organized%20removal%20service%20bright%20clean%20environment&width=800&height=600&seq=service-3&orientation=landscape',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Limpieza por síndrome de Diógenes',
      description: 'Especialistas en limpieza extrema y casos de acumulación compulsiva en Castelldefels y comarca. Equipo profesional con experiencia en situaciones delicadas, trabajando con máxima discreción, empatía y respeto. Colaboramos con servicios sociales y familias para ofrecer soluciones integrales.',
      features: [
        'Equipo especializado en limpieza extrema',
        'Máxima discreción y confidencialidad',
        'Trato humano y respetuoso',
        'Desinfección y desodorización profunda',
        'Colaboración con servicios sociales'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20protective%20equipment%20deep%20cleaning%20service%20organized%20workspace%20bright%20environment&width=800&height=600&seq=service-4&orientation=landscape',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura final',
      description: 'Servicio de pintura profesional para dejar el inmueble completamente listo en Castelldefels. Pintamos paredes, techos y elementos de carpintería. Utilizamos pinturas de alta calidad y acabados impecables. Ideal para complementar el vaciado y limpieza antes de entregar el inmueble.',
      features: [
        'Pintura de paredes y techos',
        'Preparación de superficies',
        'Pinturas de alta calidad',
        'Acabados profesionales',
        'Presupuesto incluido en el servicio integral'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20painter%20painting%20white%20walls%20bright%20clean%20room%20modern%20interior%20quality%20work&width=800&height=600&seq=service-5&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Pequeñas reparaciones',
      description: 'Realizamos pequeñas reparaciones y arreglos para entregar el inmueble en perfectas condiciones en Castelldefels y alrededores. Incluye reparación de desperfectos en paredes, puertas, ventanas, instalaciones básicas y otros elementos. Servicio complementario ideal para inmobiliarias.',
      features: [
        'Reparación de desperfectos en paredes',
        'Arreglo de puertas y ventanas',
        'Pequeñas reparaciones de fontanería',
        'Ajustes de instalaciones básicas',
        'Entrega del inmueble listo para usar'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20handyman%20repairing%20wall%20bright%20clean%20room%20organized%20tools%20modern%20interior&width=800&height=600&seq=service-6&orientation=landscape',
    },
    {
      icon: 'ri-inbox-unarchive-line',
      title: 'Vaciado de trasteros',
      description: 'Servicio especializado en limpieza y vaciado completo de trasteros en Castelldefels y alrededores. Retiramos todo tipo de objetos acumulados, muebles viejos, cajas y enseres. Incluye clasificación, gestión de residuos y reciclaje responsable. Ideal para comunidades de vecinos y particulares.',
      features: [
        'Vaciado completo de trasteros',
        'Clasificación y organización de objetos',
        'Gestión de residuos y reciclaje',
        'Servicio rápido en 24-48 horas',
        'Limpieza final del espacio'
      ],
      image: 'https://readdy.ai/api/search-image?query=Storage%20room%20clearance%20organized%20removal%20service%20bright%20clean%20space%20professional%20team&width=800&height=600&seq=service-7&orientation=landscape',
    },
    {
      icon: 'ri-hammer-line',
      title: 'Limpieza fin de obra',
      description: 'Limpieza profesional post-construcción o reforma en Castelldefels. Eliminamos polvo, restos de materiales, manchas de pintura y dejamos el espacio completamente limpio y listo para usar. Servicio especializado para constructoras, reformistas y particulares que finalizan obras.',
      features: [
        'Eliminación de polvo y escombros',
        'Limpieza de ventanas y cristales',
        'Retirada de restos de obra',
        'Pulido y abrillantado de suelos',
        'Espacio listo para habitar o entregar'
      ],
      image: 'https://readdy.ai/api/search-image?query=Post%20construction%20cleaning%20service%20professional%20team%20new%20building%20bright%20clean%20space%20modern%20interior&width=800&height=600&seq=service-8&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Desinfección y desodorización',
      description: 'Tratamiento profesional de desinfección profunda y eliminación de olores persistentes en Castelldefels. Utilizamos productos certificados y técnicas avanzadas para eliminar bacterias, virus, hongos y malos olores. Ideal para viviendas con problemas de humedad, mascotas o situaciones especiales.',
      features: [
        'Desinfección profunda con productos certificados',
        'Eliminación de olores persistentes',
        'Tratamiento contra bacterias y virus',
        'Técnicas de ozono y nebulización',
        'Certificado de desinfección'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20disinfection%20service%20team%20equipment%20sanitizing%20space%20bright%20clean%20environment%20safety%20protocols&width=800&height=600&seq=service-9&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-primary text-3xl`}></i>
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold text-graphite mb-4">
                  {service.title}
                </h2>
                
                <p className="text-lg text-gray-dark leading-relaxed mb-6">
                  {service.description}
                </p>

                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-primary text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-dark">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contacto"
                  className="inline-flex items-center px-6 py-3 border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary hover:text-white transition-all cursor-pointer whitespace-nowrap"
                >
                  Solicitar presupuesto
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="rounded-3xl overflow-hidden shadow-card">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-96 object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllServicesGrid;
